<template>
  <AIAssistantBaseChatRequest
    v-if="userRole"
    data-testid="user-message"
  >
    {{ parsedMessage }}
  </AIAssistantBaseChatRequest>
  <AIAssistantBaseChatResponse
    v-else
    data-testid="model-message"
  >
    <div class="tw:grid tw:gap-4">
      <AIAssistantBaseChatMarkdown :source="parsedMessage" />

      <div
        v-if="booleanQuery"
        class="tw:grid tw:gap-4"
        data-testid="model-boolean-query"
      >
        <QueryEditor
          disable-count
          hide-controls
          hide-help-button
          hide-label
          :model-value="booleanQuery"
          preview
          read-only
        />

        <AIAssistantActions :copy-text="booleanQuery" />
      </div>
    </div>
  </AIAssistantBaseChatResponse>
</template>

<script setup lang="ts">
import { computed } from "vue";

import AIAssistantActions from "shared/components/AI/AIAssistant/AIAssistantActions.vue";
import AIAssistantBaseChatMarkdown from "shared/components/AI/AIAssistant/AIAssistantBaseChatMarkdown.vue";
import AIAssistantBaseChatRequest from "shared/components/AI/AIAssistant/AIAssistantBaseChatRequest.vue";
import AIAssistantBaseChatResponse from "shared/components/AI/AIAssistant/AIAssistantBaseChatResponse.vue";
import QueryEditor from "shared/components/QueryEditor/QueryEditor.vue";
import { type AIChatHistory } from "shared/composables/useAIChatHistory";

interface AIChatHistoryMessageProps {
  message: AIChatHistory;
}

const props = defineProps<AIChatHistoryMessageProps>();

const userRole = computed<boolean>(() => props.message.role === "user");

const booleanQuery = computed<string>(() => props.message.booleanQuery || "");

const parsedMessage = computed<string>(
  () => props.message.prompt || props.message.text || ""
);
</script>
